import {useCallback} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import AtomIcon, {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import MoleculeDrawer, {MoleculeDrawerOverlay, moleculeDrawerPlacements} from '@s-ui/react-molecule-drawer'
import {MoleculeTextareaSizes} from '@s-ui/react-molecule-textarea-field'
import PrimitiveTypography, {primitiveTypographyDesign} from '@s-ui/react-primitive-typography'
import FormContactSeller from '@adv-mt/mt-form-contact-seller'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CLASS = 'mt-Net-contactAdDrawer'

const ContactAdDrawer = ({isOpen, ad = {}, message, extendedTrackingData, onCancel, pageName}) => {
  const {i18n, domain} = useSuiContext()

  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {LIST_TRIGGERED_EVENT, LEAD_TYPES, AUTHENTICATION_HIT_INFORMATIONS_2} = config.get('tracking')

  const handleOnContact = useCallback(() => {
    track({
      event: LIST_TRIGGERED_EVENT,
      data: {
        ...extendedTrackingData,
        lead_type: LEAD_TYPES.NET_AD_DETAIL_EMAIL
      }
    })
  }, [LEAD_TYPES.NET_AD_DETAIL_EMAIL, LIST_TRIGGERED_EVENT, extendedTrackingData, track])

  return (
    <>
      <MoleculeDrawerOverlay isVisible={isOpen} onClick={onCancel} />
      <MoleculeDrawer closeOnOutsideClick isOpen={isOpen} onClose={onCancel} placement={moleculeDrawerPlacements.RIGHT}>
        {isOpen && (
          <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}-header`}>
              <PrimitiveTypography design={primitiveTypographyDesign.HEADLINE_2}>
                {i18n.t('COMMON_CONTACT')}
              </PrimitiveTypography>
              <AtomButton
                onClick={onCancel}
                aria-label={i18n.t('NET.CLOSE_CHAT')}
                design={atomButtonDesigns.FLAT}
                leftIcon={
                  <AtomIcon size={ATOM_ICON_SIZES.medium}>
                    <IconClose />
                  </AtomIcon>
                }
              />
            </div>
            <div className={`${BASE_CLASS}-content`}>
              <FormContactSeller
                ad={ad}
                adId={ad.adId}
                contractId={ad.contractId}
                isModal={true}
                pageName={pageName}
                province={ad.mainProvince}
                showLabels={false}
                showSellerCallLinkButton={false}
                initialMessage={message}
                textareaSize={MoleculeTextareaSizes.LONG}
                onContact={handleOnContact}
                authenticationHitInformation2={AUTHENTICATION_HIT_INFORMATIONS_2.NET}
              />
            </div>
          </div>
        )}
      </MoleculeDrawer>
    </>
  )
}

ContactAdDrawer.displayName = 'ContactAdDrawer'
ContactAdDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  ad: PropTypes.object.isRequired,
  message: PropTypes.string,
  extendedTrackingData: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  pageName: PropTypes.string
}

export default ContactAdDrawer
